import DashboardLayout from "@/layouts/dashboard/DashboardLayout";

import dashboard from "./dashboard";
import products from "./products";
import users from "./users";
import settings from "./settings";
import companies from "./companies";
import sessions from "./sessions";
import services from "./services";
import sponsors from "./sponsors";
import videos from "./videos";
import subscriptions from "./subscriptions";

export default [
  {
    path: "/admin",
    component: DashboardLayout,
    meta: {
      middleware: ["auth"],
      roles: ["admin"],
    },
    children: [
      ...dashboard,
      ...products,
      ...users,
      ...settings,
      ...companies,
      ...sessions,
      ...services,
      ...sponsors,
      ...videos,
      ...subscriptions
    ],
  },
];
